module.exports = __webpack_public_path__ + "img/ai.8b2ef8f.svg";